// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__fJ1sU","rootCenter":"LoadMoreObserver_rootCenter__118vW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1veoU"};